export type LoginMethod = 'otp' | 'password'

type LoginAfterLoggedInSideEffects = Promise<string | undefined>

export type LoginAfterLoggedIn = (
  afterLoggedInSideEffectsWithPreferredLanguage: LoginAfterLoggedInSideEffects,
  method: LoginMethod,
) => void

type LoginMutationOnSuccess = (
  afterLoggedInSideEffectsWithPreferredLanguage: LoginAfterLoggedInSideEffects,
) => void

export const makeLoginAfterLoggedInForMethod = (
  afterLoggedIn: LoginAfterLoggedIn | undefined,
  method: LoginMethod,
): LoginMutationOnSuccess => {
  return (afterLoggedInSideEffectsWithPreferredLanguage): void => {
    afterLoggedIn?.(afterLoggedInSideEffectsWithPreferredLanguage, method)
  }
}
